export const FETCH_DISEASE = 'FETCH_DISEASE';
export const FETCH_DISEASE_FAILED = 'FETCH_DISEASE_FAILED';
export const FETCH_DISEASE_SUCCESS = 'FETCH_DISEASE_SUCCESS';

export const FETCH_AFRICA_SUMMARY = 'FETCH_AFRICA_SUMMARY';
export const FETCH_AFRICA_SUMMARY_FAILED = 'FETCH_AFRICA_SUMMARY_FAILED';
export const FETCH_AFRICA_SUMMARY_SUCCESS = 'FETCH_AFRICA_SUMMARY_SUCCESS';

export const FETCH_COUNTRY_DATA = 'FETCH_COUNTRY_DATA';
export const FETCH_COUNTRY_DATA_FAILED = 'FETCH_COUNTRY_DATA_FAILED';
export const FETCH_COUNTRY_DATA_SUCCESS = 'FETCH_COUNTRY_DATA_SUCCESS';
